import { ProviderSpecialtyResource } from '@provider-directory/types/providers.contracts';

/**
 * Sort specialties so `isPrimary = true` appear first, then join names with commas.
 */
export const formatSpecialties = (
  specialties: ProviderSpecialtyResource[],
): string =>
  [...specialties]
    .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary))
    .map(({ name }) => name)
    .join(', ');
